import { Base } from "ui/Scripts/source/framework/base";
import { INumberTitle, NumberTitle } from "ui/Scripts/source/models/common/numberTitle";

export interface IUserGroupIntraModule {
    code: string;
    name: string;
    level: number;
    permissions: INumberTitle[];
}

export class UserGroupIntraModule implements IUserGroupIntraModule {
    code: string;
    name: string;
    level: number;
    permissions: NumberTitle[];

    constructor();
    constructor(obj: IUserGroupIntraModule);
    constructor(obj?: any) {
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
        this.level = obj && obj.level || 0;
        this.permissions = Base.getTypedArray(obj ? obj.permissions : null, NumberTitle);
    }
}

export class UserGroupSaveIntraModule {
    code: string;
    level: string;

    constructor();
    constructor(obj: IUserGroupIntraModule);
    constructor(obj?: any) {
        this.code = obj && obj.code || "";
        this.level = obj && obj.level || 0;
    }
}